// @flow

import { SimpleErrorReport } from '@nrk/dh-simple-error-report'

export function createErrorReporter (
  name: string,
  isErrorReportingEnabled: boolean
): SimpleErrorReport {
  return new SimpleErrorReport({
    name: name,
    url: 'https://dh.nrk.no/catch',
    dryRun: !isErrorReportingEnabled
  })
}



// WEBPACK FOOTER //
// ./src/lib/errorReporting.js